// extracted by mini-css-extract-plugin
export default {"NavBar":"NavBar_NavBar__uAJAH","NavBar__NavButton":"NavBar_NavBar__NavButton__oeez9","NavBar__NavButton_IsSelected":"NavBar_NavBar__NavButton_IsSelected__WXnFe"};